export default [{
    path: 'aboutIndex',
    name: '关于我们',
    meta: {
        showFooter: true
    },
    component: () => import('../../views/about/index.vue')
}];
